import React, { useEffect, useState } from "react";

/*eslint-disable */
declare const window: any;

interface GaleriaVehiculosComponentProps {
  selectedGalery: any;
  setSelectedGalery: any;
  galeria: any;
}

const GaleriaModalVehiculosComponent: React.FC<GaleriaVehiculosComponentProps> = ({
  selectedGalery,
  setSelectedGalery,
  galeria,
}) => {
  const [currentIndex, setCurrentIndex] = useState(4);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [translateX, setTranslateX] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setCurrentIndex(selectedGalery);
  }, [selectedGalery]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : galeria?.media?.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < galeria?.media?.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handleDragStart = (e: React.MouseEvent | React.TouchEvent) => {
    setIsDragging(true);
    setStartX(e.type === "touchstart" ? (e as React.TouchEvent).touches[0].clientX : (e as React.MouseEvent).clientX);
  };

  const handleDragMove = (e: React.MouseEvent | React.TouchEvent) => {
    if (!isDragging) return;
    const currentX = e.type === "touchmove" ? (e as React.TouchEvent).touches[0].clientX : (e as React.MouseEvent).clientX;
    const deltaX = currentX - startX;
    setTranslateX(deltaX);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    if (translateX > 50) {
      handlePrev();
    } else if (translateX < -50) {
      handleNext();
    }
    setTranslateX(0);
  };

  return (
    <div className={`galeria-modal-vehiculos-detail-component ${selectedGalery !== null ? "active" : ""}`}>
      <div className="slider-galeria-vehiculos-detail-component">
        <div
          className="slider-wrapper"
          style={{
            transform:
              currentIndex === 0
                ? `translateX(${windowWidth < 768 ? "80%" : "25%"})`
                : `translateX(-${
                    windowWidth < 768
                      ? currentIndex * 70 === 70
                        ? currentIndex * 70
                        : currentIndex * 80 - 10
                      : currentIndex * 25 === 25
                      ? currentIndex * 25
                      : currentIndex * 25 === 50
                      ? currentIndex * 25 + 25
                      : currentIndex * 50 + 25 - 50
                  }%)`,
            transition: isDragging ? "none" : "transform 0.3s ease",
          }}
          onMouseDown={handleDragStart}
          onMouseMove={handleDragMove}
          onMouseUp={handleDragEnd}
          onMouseLeave={handleDragEnd}
          onTouchStart={handleDragStart}
          onTouchMove={handleDragMove}
          onTouchEnd={handleDragEnd}
        >
          {galeria?.media?.map((src: any, index: any) => (
            <div key={index} className="item-slider-galeria-modal-vehiculos-detail-component">
              {galeria?.mediaType[index] === "video" ? (
                <video src={src} autoPlay muted loop playsInline />
              ) : (
                <img src={`https://manager.hyundaicolombia.co/${src}`} alt={`Imagen del vehículo ${index + 1}`} />
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="bottom-slider-galeria-vehiculos-detail-component">
        <div className="close-bottom-slider-galeria-vehiculos-detail-component" onClick={() => setSelectedGalery(null)}>
          <img src="../assets/01_Home/Close.svg" alt="Cerrar galería" />
        </div>
        <div className="control-bottom-slider-galeria-vehiculos-detail-component">
          <div onClick={handlePrev} className="slider-button prev">
            <img src="../assets/01_Home/Icon_Left.svg" alt="Imagen anterior" />
          </div>
          <div onClick={handleNext} className="slider-button next">
            <img src="../assets/01_Home/Icon_Right.svg" alt="Imagen siguiente" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GaleriaModalVehiculosComponent;
